<template>
  <ul :id="`company-quote-panel-${instrumentId}`" class="collapsible expandable">
    <li class="active">
      <div class="collapsible-header" style="position: relative;">
        <img :src="`https://g.foolcdn.com/art/companylogos/mark/${instrument.quote.Symbol}.png`"
              class="circle"
              alt="logo"
              height="18"
        >
        &nbsp;
        <span style="margin-left: 10px;">
          <strong>{{ instrument.quote.Exchange }}:{{ instrument.quote.Symbol }}</strong>
        </span>
        <router-link :to="`/tickeradmin/editequity?instrument_id=${instrumentId}`"
                     class="amber-text"
                     v-if="$auth.hasRoles('admin', 'recs-admin')"
                     style="
                      position: absolute;
                      right: -5px;
                      top: 15px;
                     "
        >
          <i class="far fa-edit big" style="font-size: 15px;" title="Edit Instrument" />
        </router-link>
      </div>
      <div class="collapsible-body left-align">
        <ul>
          <li>
            <span class="teal-text">Beta 3Y: </span>
            {{ instrument.quote.Beta3Y }}
          </li>
          <li>
            <span class="teal-text">Bid: </span>
            {{ instrument.quote.Currency.CurrencySymbol }}{{ instrument.quote.Bid.Amount | round | thousands }}
          </li>
          <li>
            <span class="teal-text">Close Price: </span>
            {{ instrument.quote.Currency.CurrencySymbol }}{{ instrument.quote.ClosePrice.Amount | round | thousands }}
          </li>
          <li>
            <span class="teal-text">Current Price: </span>
            {{ instrument.quote.Currency.CurrencySymbol }}{{ instrument.quote.CurrentPrice.Amount | round | thousands }}
          </li>
          <li>
            <span class="teal-text">Dividend Yield: </span>
            {{ instrument.quote.DividendYield.Value }}
          </li>
          <li>
            <span class="teal-text">Earnings Per Share: </span>
            {{ instrument.quote.Currency.CurrencySymbol }}{{ instrument.quote.EarningsPerShare.Amount | round }}
          </li>
          <li>
            <span class="teal-text">Gross Margin: </span>
            {{ instrument.quote.GrossMargin | round }}%
          </li>
          <li>
            <span class="teal-text">Industry: </span>
            {{ instrument.quote.Industry }}
          </li>
          <li>
            <span class="teal-text">Market Cap: </span>
            {{ instrument.quote.Currency.CurrencySymbol }}{{ instrument.quote.MarketCap.Amount | thousands }}
          </li>
          <li>
            <span class="teal-text">Price to Earnings Ratio: </span>
            {{ instrument.quote.PriceToEarningsRatio | round }}
          </li>
          <li>
            <span class="teal-text">Return On Equity: </span>
            {{ instrument.quote.ReturnOnEquity | round }}
          </li>
          <li>
            <span class="teal-text">Revenue Growth: </span>
            {{ instrument.quote.RevenueGrowth | round }}
          </li>
          <li>
            <span class="teal-text">Shares Outstanding: </span>
            {{ instrument.quote.SharesOutstanding | thousands }}
          </li>
          <li>
            <span class="teal-text">Short Interest: </span>
            {{ instrument.quote.ShortInterest | round }}
          </li>
          <li style="border-bottom: 1px solid gainsboro;">
            <span class="teal-text">Volume: </span>
            {{ instrument.quote.Volume | thousands }}
          </li>
          <li>
            <range-price style="text-align: center; margin-top: 10px;"
                         :min="instrument.quote.FiftyTwoWeekRange.Minimum.Amount"
                         :max="instrument.quote.FiftyTwoWeekRange.Maximum.Amount"
                         :value="instrument.quote.ClosePrice.Amount"
                         v-if="instrument.id"
            />
          </li>
        </ul>
      </div>
    </li>
    <li>
      <div class="collapsible-header grey-text spotlight">Additional Details</div>
      <div class="collapsible-body left-align">
        <ul>
          <li><span class="teal-text">Instrument ID:</span> {{ instrument.id }}</li>
          <li><span class="teal-text">CapIQT:</span> {{ instrument.capiq_identifier }}</li>
          <li><span class="teal-text">APX Security ID:</span> {{ instrument.apx_security_id }}</li>
          <li><span class="teal-text">Bloomberg Ticker:</span> {{ instrument.bloomberg_ticker }}</li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import axios from 'axios';
import RangePrice from '@/components/RangePrice.vue';

export default {
  name: 'CompanyQuotePanel',
  components: { RangePrice },
  props: {
    instrumentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      instrument: {
        quote: {
          Beta3Y: 0,
          Bid: {
            Amount: 0,
          },
          ClosePrice: {
            Amount: 0,
          },
          Currency: {
            CurrencySymbol: '$',
          },
          CurrentPrice: {
            Amount: 0,
          },
          DividendYield: {
            Value: 0,
          },
          EarningsPerShare: {
            Amount: 0,
          },
          Exchange: 'NYSE',
          GrossMargin: 0,
          Industry: 'Finance',
          MarketCap: {
            Amount: 0,
          },
          PriceToEarningsRatio: 0,
          ReturnOnEquity: 0,
          RevenueGrowth: 0,
          SharesOutstanding: 0,
          ShortInterest: 0,
          Symbol: 'ABC',
          Volume: 0,
        },
      },
    };
  },
  methods: {
    initCollapsible() {
      this.materialize.Collapsible.init(document.getElementById(`company-quote-panel-${this.instrumentId}`), {
        accordion: false,
      });
    },
  },
  async mounted() {
    this.initCollapsible();
    const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/quotes/quotes/${this.instrumentId}`);
    this.instrument.quote = data;
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.collapsible-body {
  padding-bottom: 1rem;
}
</style>
